import {HttpResponse} from '@angular/common/http';
import {EditableUserProfile, UserRevisionSnapshot, UserUpdatePayload} from '../models/user-profile-snapshot.model';
import {hasServerErrorCode, ServerErrorResponse} from './server-error-code';
import {UserInfoBody} from './admin.service.types';

const HTTP_OK = 200;
const HTTP_CONFLICT = 409;
const HTTP_FORBIDDEN = 403;
const MIN_USER_REVISION = 0;
const USER_REVISION_CONFLICT = 'USER_REVISION_CONFLICT';
const USER_MEMBERSHIP_CHANGE_UNSUPPORTED = 'USER_PROFILE_MEMBERSHIP_CHANGE_UNSUPPORTED';
const USER_PRIMARY_GROUP_PAYROLL_CONFLICT = 'USER_PRIMARY_GROUP_PAYROLL_CONFLICT';
const INVALID_SNAPSHOT = 'USER_PROFILE_SNAPSHOT_UNAVAILABLE';

export const USER_PROFILE_ERROR = {
  conflict: 'USER_PROFILE_REVISION_CONFLICT', save: 'USER_PROFILE_SAVE_FAILED',
  reload: 'USER_PROFILE_RELOAD_FAILED', forbidden: 'USER_PROFILE_ACCESS_DENIED',
  membership: 'USER_PROFILE_MEMBERSHIP_CHANGE_UNSUPPORTED', payroll: 'USER_PRIMARY_GROUP_PAYROLL_CONFLICT'
};

export function hasUserRevision(user: UserRevisionSnapshot): boolean {
  return !!user && Number.isSafeInteger(user.userRevision) && user.userRevision >= MIN_USER_REVISION;
}

export function userProfileErrorKey(error: ServerErrorResponse): string {
  if (error && error.status === HTTP_CONFLICT && hasServerErrorCode(error, USER_REVISION_CONFLICT)) {
    return USER_PROFILE_ERROR.conflict;
  }
  if (error && error.status === HTTP_CONFLICT && hasServerErrorCode(error, USER_MEMBERSHIP_CHANGE_UNSUPPORTED)) {
    return USER_PROFILE_ERROR.membership;
  }
  if (error && error.status === HTTP_CONFLICT && hasServerErrorCode(error, USER_PRIMARY_GROUP_PAYROLL_CONFLICT)) {
    return USER_PROFILE_ERROR.payroll;
  }
  return error && error.status === HTTP_FORBIDDEN ? USER_PROFILE_ERROR.forbidden : USER_PROFILE_ERROR.save;
}

export function readProfileUser(response: HttpResponse<EditableUserProfile>, userId: string): EditableUserProfile {
  if (response.status !== HTTP_OK || !hasUserRevision(response.body) || response.body.id !== userId) {
    throw new Error(INVALID_SNAPSHOT);
  }
  return response.body;
}

export function readProfileGroups(user: EditableUserProfile, response: HttpResponse<UserInfoBody>): UserUpdatePayload {
  if (response.status !== HTTP_OK || !response.body || !Array.isArray(response.body.groupsWithPositions)) {
    throw new Error(INVALID_SNAPSHOT);
  }
  return {user: user, groupsWithPositions: response.body.groupsWithPositions};
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/user-profile-snapshot.ts